import { FiChevronUp, FiChevronDown } from 'react-icons/fi';

export function MarketSwitcher({
  showDesktop,
  showMobile,
  dockOpen,
  activeMarketIndex,
  marketDataLength,
  hasNext,
  onPrev,
  onNext
}) {
  const isAtStart = activeMarketIndex === 0;
  const isAtEnd = activeMarketIndex >= marketDataLength - 1 && !hasNext;

  if (!showDesktop && !showMobile) return null;

  // Desktop version
  if (showDesktop) {
    return (
      <div className="glass-md hidden lg:flex fixed right-6 top-1/2 -translate-y-1/2 flex-col w-12 bg-glass-dark border border-slate-600/60 rounded-[48px] overflow-hidden z-50 backdrop-blur-xl">
        <button
          onClick={() => activeMarketIndex > 0 && onPrev()}
          aria-label="上一个市场"
          disabled={isAtStart}
          className={`w-12 h-12 border-none bg-transparent text-text transition-all duration-200 flex items-center justify-center text-base md:text-lg border-b border-slate-600/40 ${isAtStart ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:text-sky-200 hover:bg-sky-400/15 active:bg-sky-400/25'}`}
        >
          <FiChevronUp />
        </button>
        <button
          onClick={onNext}
          aria-label="下一个市场"
          disabled={isAtEnd}
          className={`w-12 h-12 border-none bg-transparent text-text transition-all duration-200 flex items-center justify-center text-base md:text-lg ${isAtEnd ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:text-sky-200 hover:bg-sky-400/15 active:bg-sky-400/25'}`}
        >
          <FiChevronDown />
        </button>
      </div>
    );
  }

  // Mobile version
  return (
    <div className={`glass-md fixed left-1/2 -translate-x-1/2 bottom-20 flex lg:hidden flex-row gap-0 rounded-3xl overflow-hidden w-auto z-40 transition-opacity duration-300 ${dockOpen ? 'opacity-0 pointer-events-none' : ''}`}>
      <button
        onClick={() => activeMarketIndex > 0 && onPrev()}
        aria-label="上一个"
        disabled={isAtStart}
        className={`w-14 h-12 border-none bg-transparent text-text border-r border-slate-600/40 flex items-center justify-center text-base md:text-lg ${isAtStart ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:text-sky-200 hover:bg-sky-400/15'}`}
      >
        <FiChevronUp />
      </button>
      <button
        onClick={onNext}
        aria-label="下一个"
        disabled={isAtEnd}
        className={`w-14 h-12 border-none bg-transparent text-text flex items-center justify-center text-base md:text-lg ${isAtEnd ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:text-sky-200 hover:bg-sky-400/15'}`}
      >
        <FiChevronDown />
      </button>
    </div>
  );
}
